export default __webpack_public_path__ + "static/media/videolink.1acb452a.svg";